// 解錠コマンドの書込自体が失敗した終端（#7709 T12）。取引 API の HTTP 失敗（T6・閉じ禁止）と
// 同じ画面 catch に混流する前に、発生源で出自を型として刻む。元のrejection値をoriginalErrorで無損失保持する。
// 消費者は autoClosePolicy.shouldAutoCloseProcess（instanceof に該当せず false=開いたまま網に残す）と
// UnlockPage の画面分類（ResultWaitTimeoutException 等の判定から漏れて UnknownError 表示になる）の2箇所。
// classifyFailure（standOperationRepository）は接続確立フェーズ専用で、本例外は接続後の write 局面
// (usecase層)で投げられるためそこには到達しない。
// フィールド名がoriginalErrorなのは、TS4.6.2同梱libの Error.cause 型（Error|undefined）と衝突して
// unknownを保てなくなるのを避けるため。
export class WriteFailedException extends Error {
  constructor(readonly originalError?: unknown) {
    super('unlock command write failed')
    this.name = 'WriteFailedException'
    // es5 ターゲットで instanceof を機能させる
    Object.setPrototypeOf(this, WriteFailedException.prototype)
  }
}
